import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { Notification } from "carbon-components-react";
import { ToastNotification, showToast, TOAST_TYPE } from "@acadia-ui/toast";

let errorHelpersRoot = null;

const ErrorHelpers = {
	resetErrors: (formEl) => {
		const inputErrors = document.querySelectorAll(`#${formEl} [class^=errors__]`);
		for (const input of inputErrors) {
			ReactDOM.unmountComponentAtNode(input);
			input.classList.remove("show");
		}

		const formErrors = document.querySelector(`#${formEl} #errors__container`);
		if (formErrors) {
			ReactDOM.unmountComponentAtNode(formErrors);
		}

		if (errorHelpersRoot) {
			errorHelpersRoot.unmount();
		}
	},

	resetCalculateErrors: (formEl) => {
		const inputErrors = document.querySelectorAll(`#${formEl} .rateBuilderContainer [class^=errors__]`);
		for (const input of inputErrors) {
			ReactDOM.unmountComponentAtNode(input);
			input.classList.remove("show");
		}
	},

	displayErrors: (formEl, errors, type) => {
		/* Reset them first */
		ErrorHelpers.resetErrors(formEl);
		const objKeys = Object.keys(errors);
		if (objKeys.length > 0) {
			for (const selector of objKeys) {
				if (selector === "Errors") {
					ErrorHelpers.buildFormErrors(formEl, selector, errors[selector]);
				} else {
					ErrorHelpers.buildInputError(formEl, selector, errors[selector]);
				}
			}
			const errorKeys = [];
			const errorCollection = [];
			Object.keys(errors).forEach((key) => {
				errorKeys.push(key);
			});
			// errorKeys.forEach(key => {
			// 	if (document.getElementsByClassName(`${type} ${key} required like--label`)[0]) {
			// 		errorCollection.push([...document.getElementsByClassName(`${type} ${key} required like--label`)][0]);
			// 	}
			// });
			errorKeys.forEach((key) => {
				if (document.getElementsByClassName(`errors__${key}`)[0]) {
					errorCollection.push([...document.getElementsByClassName(`errors__${key}`)][0]);
				}
			});

			if (errorCollection[0] !== undefined) {
				errorCollection[0].scrollIntoView();
			}
		}
	},

	buildFormErrors: (formEl, selector, errors) => {
		try {
			const domEl = document.querySelector(`#${formEl} #errors__container`);
			const errorsArray = errors.map((error, index) => ErrorHelpers.buildNotification(error, index));
			errorHelpersRoot = createRoot(domEl);
			errorHelpersRoot.render(errorsArray);
		} catch (e) {
			console.error("Error rendering form errors: ", e);
		}
	},

	buildNotification: (error, index) => <Notification key={index} kind="error" role="inline" title={error} subtitle="" hideCloseButton iconDescription={error} />,

	buildInputError: (formEl, selector, message) => {
		// const domEl = document.querySelector(`#${formEl} .errors__${selector}`);
		const domEl = document.querySelector(`.errors__${selector}`);
		if (domEl !== null) {
			domEl.classList.add("show");
			domEl.innerText = message;
		}
	},

	displayErrorToasts: async (error, toastContainerId, defaultError) => {
		try {
			const errorObject = await error.details.json();
			errorObject?.Errors?.forEach((errorMessage) => {
				setTimeout(() => showToast(toastContainerId, <ToastNotification type={TOAST_TYPE.ERROR} message={errorMessage} />), 0);
			});
		} catch (e) {
			showToast(toastContainerId, <ToastNotification type={TOAST_TYPE.ERROR} message={defaultError} />);
		}
	}
};

export default ErrorHelpers;
